var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"mail-content"},domProps:{"innerHTML":_vm._s(_vm.htmlBody)}}),_vm._v(" "),(_vm.signature)?_c('div',{staticClass:"mail-signature",domProps:{"innerHTML":_vm._s(_vm.htmlSignature)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }